import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  TenantDTO,
  ProductDTO,
  OverrideTypeDTO,
  HcpcsCodeListDTO,
  HcpcsSearchResultDTO,
  HcpcsAssociationDTO,
  SaveHcpcsRequestDTO,
  SaveHcpcsWithAssociationDTO,
  DmeposCategoryDTO,
  FormIoDto,
  HcpcsGetRequestDTO,
  HcpcsGetResponseDTO,
  HcpcsCodeModifierDTO,
  DeactivateCodeResponse
} from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class CodeManagementApiService {
  public selectedTenant: string | null = null;
  public selectedProgram: string | null = null;
  public selectedPlan: string | null = null;

  constructor(private apiService: ApiService) {}

  getCodes(request: HcpcsGetRequestDTO): Observable<HcpcsGetResponseDTO> {
    return this.apiService.post<HcpcsGetResponseDTO>('/api/Codes/getHcpcs', request);
  }

  getTenants(): Observable<TenantDTO[]> {
    return this.apiService.get('/api/Tenant');
  }

  getAllProducts(): Observable<ProductDTO[]> {
    return this.apiService.get('/api/Product');
  }

  getPlans(tenantId: string, productId: string): Observable<OverrideTypeDTO[]> {
    return this.apiService.get(`/api/Override/tenant/${tenantId}/product/${productId}`);
  }

  searchCodes(searchTerm: string): Observable<HcpcsCodeListDTO[]> {
    return this.apiService.get(`/api/Codes/searchHcpcsCode?searchTerm=${encodeURIComponent(searchTerm)}`);
  }

  getCodeDetails(hcpcsId: string): Observable<HcpcsSearchResultDTO> {
    return this.apiService.get(`/api/Codes/${hcpcsId}`);
  }

  getCodeAssociations(hcpcsId: string, productId: string, tenantId: string, overrideTypeId: string): Observable<HcpcsAssociationDTO> {
    const url = `/api/Codes/${hcpcsId}/associations?productId=${encodeURIComponent(productId)}&tenantId=${encodeURIComponent(tenantId)}&overrideTypeId=${encodeURIComponent(overrideTypeId)}`;
    return this.apiService.get<HcpcsAssociationDTO>(url);
  }

  saveHcpcsWithAssociation(request: SaveHcpcsRequestDTO): Observable<SaveHcpcsWithAssociationDTO> {
    return this.apiService.post('/api/Codes/associations', request);
  }

  getDmeposCategories(tenantId: string, productId: string): Observable<DmeposCategoryDTO[]> {
    return this.apiService.get(`/api/HcpcsCategory/categories?tenantId=${tenantId}&productId=${productId}`);
  }

  getAllModifiers(): Observable<HcpcsCodeModifierDTO[]> {
    return this.apiService.get('/api/Codes/modifiers');
  }

  getCategoryForHcpcs(hcpcsId: string, tenantId: string): Observable<string | null> {
    return this.apiService.get(`/api/HcpcsCategory/hcpcs/${hcpcsId}/category?tenantId=${tenantId}`);
  }

  searchClinicalForms(searchString: string): Observable<FormIoDto[]> {
    return this.apiService.get(`/api/HcpcsForm/search?searchString=${encodeURIComponent(searchString)}`);
  }

  getForm(formIoId: string, tenantId: string): Observable<any> {
    return this.apiService.get(`/api/HcpcsForm/${tenantId}/${encodeURIComponent(formIoId)}`);
  }
  
  getModifiers(): Observable<HcpcsCodeModifierDTO[]> {
    return this.apiService.get<HcpcsCodeModifierDTO[]>('/api/Codes/modifiers');
  }

  deleteCode(hcpcsId: string, tenantId: string): Observable<DeactivateCodeResponse> {
    return this.apiService.delete(`/api/Codes/${hcpcsId}?tenantId=${tenantId}`);
  }

  isModifierInUseByAuthorization(hcpcsByModifierId: string, tenantId: string): Observable<boolean> {
    return this.apiService.get<boolean>(`/api/Codes/modifiers/${hcpcsByModifierId}/validate-modifier?tenantId=${tenantId}`);
  }
}
